﻿export const de = {
  apply: "Anwenden",
  cart_is_empty: "Ihr Warenkorb ist leer. Produkte entdecken und in den Warenkorb legen",
  browse_products: "Produkte durchsuchen",
  invalid_coupon: "Sie haben einen ungültigen Rabattcode eingegeben. Bitte überprüfen Sie den Code und versuchen Sie es erneut.",
  duplicate_coupon: "Der Rabattcode {{couponInputValue}} wurde bereits angewendet",
  products: "Produkte",
  product: "Produkt",
  qty: "Menge",
  price: "Preis",
  remove: "Entfernen",
  add_to_cart: "In den Warenkorb legen",
  show_more: "Mehr anzeigen",
  show_less: "Weniger anzeigen",
  order_summary: "Zusammenfassung der Bestellung",
  your_cart: "Ihr Warenkorb",
  item: "Artikel",
  items: "Artikel",
  enter_discount_code: "Rabattcode eingeben",
  continue_shopping: "Weiter einkaufen",
  i_agree: "Indem ich fortfahre, erkläre ich, dass ich die folgenden Bedingungen gelesen habe und diese akzeptiere:",
  privacy_policy: "Datenschutzerklärung",
  refund_policy: "Rückerstattungsrichtlinie",
  terms_of_use: "Nutzungsbedingungen",
  and: "und",
  total: "Gesamtbetrag",
  exclude: "Exkl.",
  include: "Inkl.",
  tax: "Steuer",
  subtotal: "Zwischensumme",
  discount: "Rabatt",
  coupon_discount: "Rabatt mit Coupon",
  checkout: "Kasse"
};